import request from '@/utils/request';

export function getUserList(query = {}) {
  return request({
    url: '/admin/sysAdmin/list',
    method: 'get',
    params: query,
  });
}

export function addUser(data) {
  return request({
    url: '/admin/sysAdmin',
    method: 'post',
    data: data,
  });
}

// 课程
export function getCourseCateAll(params) {
  return request({
    url: '/admin/common/courseCate/all',
    method: 'get',
    params,
  });
}
// 白名单
export function getWhitelistInfo(params) {
  return request({
    url: '/admin/whitelist/info',
    method: 'get',
    params,
  });
}
// 白名单
export function addWhitelistInfo(data) {
  return request({
    url: '/admin/whitelist',
    method: 'post',
    data,
  });
}

// 删除用户
export function removeUser(data) {
  return request({
    url: '/admin/sysAdmin/batchRemove',
    method: 'delete',
    data: data,
  });
}

// 关闭用户
export function closeUser(data) {
  return request({
    url: '/admin/sysAdmin/editState',
    method: 'put',
    data: data,
  });
}

// 修改用户信息
export function updateUser(data) {
  return request({
    url: `/admin/sysAdmin/${data.id}`,
    method: 'put',
    data: data,
  });
}

// 用户详情
export function getUserDetail(query = {}) {
  return request({
    url: `/admin/sysAdmin/${query.id}`,
    method: 'get',
    params: query,
  });
}

export function sysLogin(id) {
  return request({
    url: `/admin/sysAdmin/login/${id}`,
    method: 'get',
  });
}

export function schoolList() {
  return request({
    url: `/admin/sysAdmin/schoolList`,
    method: 'get',
  });
}

// 角色管理
export function getRole(query = {}) {
  return request({
    url: '/admin/sysRole/list',
    method: 'get',
    params: query,
  });
}

// 角色管理
export function getRoleAll(query = {}) {
  return request({
    url: '/admin/sysRole/listAll',
    method: 'get',
    params: query,
  });
}

// 获取角色信息
export function getRoleDetail(data) {
  return request({
    url: `/admin/sysRole/${data}`,
    method: 'get',
  });
}

// 编辑角色信息
export function compileRole(id, data) {
  return request({
    url: `/admin/sysRole/${id}`,
    method: 'put',
    data: data,
  });
}

// 添加角色
export function addRole(data) {
  return request({
    url: '/admin/sysRole',
    method: 'post',
    data: data,
  });
}

// 删除角色信息
export function delRole(data) {
  return request({
    url: '/admin/sysRole/batchRemove',
    method: 'delete',
    data: data,
  });
}

// 批量管理角色状态
export function editStatus(data) {
  return request({
    url: '/admin/sysRole/editState',
    method: 'put',
    data: data,
  });
}

// 查询所有数据
export function getAuthAll(query = {}) {
  return request({
    url: '/admin/sysAuthority/listAll',
    method: 'get',
    params: query,
  });
}

export function getAuthAllTree(query = {}) {
  return request({
    url: '/admin/sysAuthority/listAllTree',
    method: 'get',
    params: query,
  });
}

// 权限管理列表
export function getAuth(query = {}) {
  return request({
    url: '/admin/sysAuthority/list',
    method: 'get',
    params: query,
  });
}

// 权限信息
export function getAuthDetail(data) {
  return request({
    url: `/admin/sysAuthority/${data}`,
    method: 'get',
  });
}

// 编辑权限信息
export function compileAuth(data) {
  return request({
    url: `/admin/sysAuthority/${data.id}`,
    method: 'put',
    data,
  });
}

// 新增权限
export function editAuth(data) {
  return request({
    url: '/admin/sysAuthority',
    method: 'post',
    data: data,
  });
}

// 删除权限
export function delAuth(data) {
  return request({
    url: '/admin/sysAuthority/batchRemove',
    method: 'delete',
    data: data,
  });
}

// 操作日志
export function getLogs(query = {}) {
  return request({
    url: '/admin/sysLog/list',
    method: 'get',
    params: query,
  });
}

// 年级管理
export function getGrades(query = {}) {
  return request({
    url: '/admin/grade/list',
    method: 'get',
    params: query,
  });
}

export function saveGrades(query = {}) {
  return request({
    url: '/admin/grade',
    method: 'post',
    data: query,
  });
}

export function deleteGrades(id) {
  return request({
    url: '/admin/grade/' + id,
    method: 'delete',
  });
}

export function updateGrades(id, query) {
  return request({
    url: '/admin/grade/' + id,
    method: 'put',
    data: query,
  });
}

export function updateGradeStatus(query) {
  return request({
    url: '/admin/grade/batchEnable',
    method: 'put',
    data: query,
  });
}

// 学科管理
export function getSubjects(query = {}) {
  return request({
    url: '/admin/subjects/list',
    method: 'get',
    params: query,
  });
}

export function saveSubjects(query = {}) {
  return request({
    url: '/admin/subjects',
    method: 'post',
    data: query,
  });
}

export function deleteSubjects(id) {
  return request({
    url: '/admin/subjects/' + id,
    method: 'delete',
  });
}

export function updateSubjects(id, query) {
  return request({
    url: '/admin/subjects/' + id,
    method: 'put',
    data: query,
  });
}

export function updateSubjectStatus(query) {
  return request({
    url: '/admin/subjects/batchEnable',
    method: 'put',
    data: query,
  });
}

// 广告位管理
export function getPosition(query = {}) {
  return request({
    url: '/admin/position/list',
    method: 'get',
    params: query,
  });
}

export function savePosition(query = {}) {
  return request({
    url: '/admin/position',
    method: 'post',
    data: query,
  });
}

export function deletePosition(query) {
  return request({
    url: '/admin/position',
    method: 'delete',
    data: query,
  });
}

export function updatePosition(id, query) {
  return request({
    url: '/admin/position/' + id,
    method: 'put',
    data: query,
  });
}

export function updatePositionStatus(query) {
  return request({
    url: '/admin/position/batchClose',
    method: 'put',
    data: query,
  });
}

// banner管理
export function getBanner(query = {}) {
  return request({
    url: '/admin/banner/list',
    method: 'get',
    params: query,
  });
}

export function getBannerInfo(id) {
  return request({
    url: '/admin/banner/' + id,
    method: 'get',
  });
}

export function saveBanner(query = {}) {
  return request({
    url: '/admin/banner',
    method: 'post',
    data: query,
  });
}

export function deleteBanner(query) {
  return request({
    url: '/admin/banner',
    method: 'delete',
    data: query,
  });
}

export function updateBanner(id, query) {
  return request({
    url: '/admin/banner/' + id,
    method: 'put',
    data: query,
  });
}

export function updateBannerStatus(query) {
  return request({
    url: '/admin/banner/batchClose',
    method: 'put',
    data: query,
  });
}

// 积分配置
export function getPointsConfig(query = {}) {
  return request({
    url: '/admin/pointsConfig/all',
    method: 'get',
    params: query,
  });
}

export function setPointsConfig(data) {
  return request({
    url: '/admin/pointsConfig/batchUpdate',
    method: 'put',
    data,
  });
}

// 获取申报审核地区tree
export function getApplyAreaTree() {
  return request({
    url: '/admin/sysAdmin/auditArea',
    method: 'get',
  });
}

// 获取同步课程申报审核地区tree
export function getAsyncApplyAreaTree() {
  return request({
    url: '/admin/sysAdmin/auditCity',
    method: 'get',
  });
}
// 获取同步课程课时审核学段学科tree
export function getAuditPeriodAndSubject() {
  return request({
    url: '/admin/sysAdmin/tbkcAuditPeriodAndSubject',
    method: 'get',
  });
}

// 获取申报审核学段学科tree
export function getApplyPeriodAndSubjectTree(query = {}) {
  return request({
    url: '/admin/sysAdmin/auditPeriodAndSubject',
    method: 'get',
    params: query,
  });
}

// 查看是否需要校验短信
export function getSmsButton() {
  return request({
    url: '/admin/verification/smsButton',
    method: 'get',
  });
}
// 设置是否需要校验短信
export function setSmsButton(data) {
  return request({
    url: '/admin/smsButton',
    method: 'post',
    data,
  });
}
// 是否申报短信
export function getSmsButtonSelection(data) {
  return request({
    url: '/admin/smsButton/selection',
    method: 'get',
    data,
  });
}
export function getOneOpenInfo(data) {
  return request({
    url: '/admin/oneOpen/info',
    method: 'get',
    data,
  });
}
export function setOneOpenValue(data) {
  return request({
    url: '/admin/oneOpen',
    method: 'post',
    data,
  });
}
export function setSmsButtonSelection(data) {
  return request({
    url: '/admin/smsButton/selection',
    method: 'post',
    data,
  });
}

export function getBlackIpList(params) {
  return request({
    url: `/admin/blackIp/list`,
    method: 'get',
    params,
  });
}

export function addBlackIpList(data) {
  return request({
    url: `/admin/blackIp`,
    method: 'post',
    data,
  });
}

export function removeBlackIpList(data) {
  return request({
    url: `/admin/blackIp`,
    method: 'delete',
    data,
  });
}
// 机构相关
export function getAdminOrgList(params) {
  return request({
    url: `/admin/org/list`,
    method: 'get',
    params,
  });
}
export function removeAdminOrg(data) {
  return request({
    url: '/admin/org',
    method: 'delete',
    data: data,
  });
}
export function closeAdminOrg(data) {
  return request({
    url: '/admin/org',
    method: 'put',
    data: data,
  });
}

export function getAdminOrgDetail(query = {}) {
  return request({
    url: `/admin/org/${query.id}`,
    method: 'get',
    params: query,
  });
}

export function getCommonBaseRedOrgList(query = {}) {
  return request({
    url: `/admin/common/redOrg/list`,
    method: 'get',
    params: query,
  });
}
export function getCommonBaseOrgList(query = {}) {
  return request({
    url: `/admin/common/baseOrg/list`,
    method: 'get',
    params: query,
  });
}

export function addOrg(data) {
  return request({
    url: '/admin/org',
    method: 'post',
    data: data,
  });
}

export function updateOrg(data) {
  return request({
    url: `/admin/org/${data.id}`,
    method: 'put',
    data: data,
  });
}
// 字典控制相关

// CONTACT("contact","联系我们"),
// PAY_INTRO("payIntro","缴费介绍"),
// POLITICAL_STATUS("politicalStatus","政治面貌"),
// ETHNIC("ethnic","民族"),
// EDU("edu","文化程度"),
// JOB("job","职业"),
export function getAdminDict(type) {
  return request({
    url: `/admin/dict/${type}`,
    method: 'get',
  });
}
export function saveAdminDict(data) {
  return request({
    url: `/admin/dict`,
    method: 'post',
    data
  });
}
export function getCommonDictList(query = {}) {
  return request({
    url: '/admin/common/dict/list',
    method: 'get',
    params: query,
  });
}